import React from 'react'

import { RHFInput } from 'react-hook-form-input'
import useForm from 'react-hook-form'
import humps from 'humps'

import {
  Typography,
  TextField,
  Box,
  Button,
  makeStyles,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from '@material-ui/core'

import useAuth from 'hooks/useAuth'
import Help from '@material-ui/icons/Help'
import schemas from './../../../../schemas'
import styles from './styles'
import helpers from 'helpers'

const useStyles = makeStyles(styles)

const SettingsNFeForm = ({
  settings,
  configGateway,
  handleClose,
  onSubmit,
}) => {
  const classes = useStyles()
  const auth = useAuth()

  const {
    register,
    setValue,
    errors,
    handleSubmit,
    watch,
    unregister,
  } = useForm({
    validationSchema: auth.seller.isMarilia
      ? schemas.taxInvoiceYapay
      : schemas.taxInvoiceNfeIo,
    defaultValues: {
      daysToGenerateNFe: settings.daysToGenerateNFe.value,
      simplesNacionalNFe: settings.simplesNacionalNFe.value,
      generateInCurrentMonthNfe: !!parseInt(
        settings.generateInCurrentMonthNfe.value,
      ),
      enableSimplesNacionalCheckbox: settings.simplesNacionalNFe.value !== '',
      ...helpers.taxInvoiceSellers.configGatewayToObject(configGateway),
      generateNFeOnInvoiceCreate: !!parseInt(
        settings.generateNFeOnInvoiceCreate?.value,
      ),
    },
  })

  const enableSimplesNacional = watch('enableSimplesNacionalCheckbox')
  const enableNFeFromFinalizedInvoice = watch('generateNFeOnInvoiceCreate')

  const handleCheckClick = event => {
    if (!event.target.checked) {
      unregister('daysToGenerateNFe')
      unregister('generateInCurrentMonthNfe')
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classes.root}>
      <Box display="flex" flexDirection="column">
        <RHFInput
          as={
            <FormControlLabel
              className={classes.tooltippedInput}
              control={<Checkbox />}
              label="Gerar Nota Fiscal na criação da fatura."
            />
          }
          register={register}
          setValue={setValue}
          type="checkbox"
          name="generateNFeOnInvoiceCreate"
          onChange={handleCheckClick}
        />

        {!enableNFeFromFinalizedInvoice && (
          <>
            <RHFInput
              as={
                <TextField
                  type="number"
                  margin="dense"
                  error={!!errors.daysToGenerateNFe}
                  helperText={
                    errors.daysToGenerateNFe && errors.daysToGenerateNFe.message
                  }
                  label="Gerar quantos dias antes do vencimento?"
                  fullWidth
                />
              }
              register={register}
              setValue={setValue}
              name="daysToGenerateNFe"
            />
            <Box display="flex" alignItems="center">
              <RHFInput
                as={
                  <FormControlLabel
                    className={classes.tooltippedInput}
                    control={<Checkbox />}
                    label="Gerar nota fiscal dentro do mês corrente?"
                  />
                }
                register={register}
                setValue={setValue}
                type="checkbox"
                name="generateInCurrentMonthNfe"
              />
              <Tooltip
                classes={{ tooltip: classes.tooltipWidth }}
                title="Ao gerar a fatura e agendar a geração da NFe conforme a configuração de dias antes do vencimento, caso a data de agendamento não seja o mês atual, gera a NFe no dia da geração da fatura."
                placement="right"
              >
                <Help />
              </Tooltip>
            </Box>
          </>
        )}

        <div>
          <RHFInput
            as={
              <FormControlLabel
                control={<Checkbox />}
                label="Optante Simples Nacional?"
              />
            }
            register={register}
            setValue={setValue}
            type="checkbox"
            name="enableSimplesNacionalCheckbox"
          />
        </div>
        {enableSimplesNacional && (
          <RHFInput
            as={
              <TextField
                type="number"
                margin="dense"
                error={!!errors.simplesNacionalNFe}
                helperText={
                  errors.simplesNacionalNFe && errors.simplesNacionalNFe.message
                }
                label="Valor da alíquota do Simples Nacional (%)"
                fullWidth
              />
            }
            register={register}
            setValue={setValue}
            name="simplesNacionalNFe"
          />
        )}
      </Box>

      <Typography variant="h5" className={classes.subTitle}>
        Configurações de emissão
      </Typography>

      {configGateway.map(config => (
        <RHFInput
          as={
            <TextField
              type="text"
              margin="dense"
              error={!!errors[humps.camelize(config.tag)]}
              helperText={
                errors[humps.camelize(config.tag)] &&
                errors[humps.camelize(config.tag)].message
              }
              label={config.description}
              fullWidth
            />
          }
          register={register}
          setValue={setValue}
          name={humps.camelize(config.tag)}
          key={humps.camelize(config.tag)}
        />
      ))}

      <Box pt={2}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.btnSave}
        >
          Salvar
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={handleClose}
        >
          Cancelar
        </Button>
      </Box>
    </form>
  )
}

export default SettingsNFeForm
